import React, { useState, useEffect } from 'react';
import Filters from '../../components/Filters';
import { Form } from 'react-bootstrap';
import MultiSelectField from '../../components/form/MultiSelectField';
import ToggleSwitch from '../../components/ToggleSwitch';
import LeaseOffer from '../../models/LeaseOffer.js';
import Multiselect from 'multiselect-react-dropdown';
import { getApi } from '../../api/endpoints.js';

const FormPartial = (props) => {
  const { leaseOffer, setLeaseOffer } = props;
  let leaseOfferObj = new LeaseOffer(leaseOffer);
  const [businessUnits, setBusinessUnits] = useState([]);
  const [bikes, setBikes] = useState([]);
  const [businessUnitsApi] = getApi('business_units')
  const [bikesApi] = getApi('bikes')

  const validateValue = (field) => {
    new LeaseOffer(leaseOffer).validate(field);
    props.setLeaseOffer(leaseOfferObj.toStateJson());
  }

  useEffect(()=>{
    fetchOptions();
  }, [])

  useEffect(()=>{
  }, [ leaseOffer ])

  const fetchOptions = async () =>{
    try{
      let business_units_response = await businessUnitsApi({id: props.fleet_owner_id ? props.fleet_owner_id :1207}).unwrap();
      setBusinessUnits(business_units_response.data.business_units)
      let bikes_response = await bikesApi({fields: "options"}).unwrap();
      setBikes(bikes_response.data.bikes)
    } catch(error) {

    }
  }

  const changeValue = (field, value) => {
    setLeaseOffer((prevState) => {
      return { ...prevState, [field]: value }
    });
  }

  const onBusinessUnitSelect = (selectedList, selectedItem) => {
    setLeaseOffer((prevState)=> {
      return {...prevState, business_units: [ ...prevState.business_units, selectedItem ]}
    })
  }

  const onBusinessUnitRemove = (selectedList, removedItem) => {
    setLeaseOffer((prevState) => {
      return { ...prevState, business_units: leaseOffer.business_units.filter((business_unit) => removedItem.id !== business_unit.id) }
    })
  }

  const onBikeSelect = (selectedList, selectedItem) => {
    setLeaseOffer((prevState)=> {
      return { ...prevState, bikes: [ ...prevState.bikes, selectedItem ] }
    })
  }

  const onBikeRemove = (selectedList, removedItem) => {
    setLeaseOffer((prevState) => {
      return { ...prevState, bikes: leaseOffer.bikes.filter((bike) => removedItem.id !== bike.id) }
    })
  }

  const handleRentalToggle = (e) => {
    leaseOfferObj.is_rental = !leaseOfferObj.is_rental;
    setLeaseOffer(leaseOfferObj.toStateJson())
  }

  const handleSkipFirstEmiToggle = (e) => {
    leaseOfferObj.skip_first_emi = !leaseOfferObj.skip_first_emi;
    setLeaseOffer(leaseOfferObj.toStateJson())
  }

  const handleHasSwapCreditOnEmiPayment = (e) => {
    leaseOfferObj.has_emi_frequency_days = !leaseOfferObj.has_emi_frequency_days;
    setLeaseOffer(leaseOfferObj.toStateJson())
  }

  return <>
    <div className="mt-4">
      <div className="row">
        <div className="col-md-6 my-2">
          <label htmlFor="sloc" className="form-label">Lease Offer Name</label>
          <input
            value={leaseOffer.name}
            onChange={(e) => changeValue('name', e.target.value)}
            type="text"
            className="form-control form-control-sm font-size-12"
            id="name" placeholder='Enter Name'
            // onBlur={(e) => validateValue('name')}
          />
        </div>
        <div className="col-md-6 my-2">
          <label htmlFor="offer_type" className="form-label">EMI Payment Duration</label><br/>
          <span className="p-3">
            <input onChange={(e) => changeValue('emi_payment_frequency_days', e.target.value) } type="radio" id="day" name="lease_duration" value="1" checked={[1,"1"].includes(leaseOfferObj.emi_payment_frequency_days)}/>
            <label htmlFor="day">Daily</label>
          </span>
          <span className="p-3">
            <input onChange={(e) => changeValue('emi_payment_frequency_days', e.target.value) } type="radio" id="week" name="lease_duration" value="7" checked={[7,"7"].includes(leaseOfferObj.emi_payment_frequency_days)}/>
            <label htmlFor="week">Weekly</label>
          </span>
          <span className="p-3">
            <input onChange={(e) => changeValue('emi_payment_frequency_days', e.target.value) } type="radio" id="month" name="lease_duration" value="30" checked={[30,"30"].includes(leaseOfferObj.emi_payment_frequency_days)}/>
            <label htmlFor="month">Monthly</label>
          </span>
          <span className="p-3">
              <input
                value={leaseOffer.emi_payment_frequency_days}
                onChange={(e) => changeValue('emi_payment_frequency_days', e.target.value)}
                type="number"
                id="emi_payment_frequency_days"
                placeholder='Enter Duration'
              />
          </span>
        </div>
      </div>
      <div className="row">
        <div className="col-md-4 my-2">
          <label htmlFor="tenure" className="form-label">No. of EMIs</label>
          <input
            value={leaseOffer.no_of_emis}
            onChange={(e) => changeValue('no_of_emis', e.target.value)}
            type="number"
            className="form-control form-control-sm font-size-12"
            id="tenure" placeholder='Enter no. of EMIs'
            // onBlur={(e) => validateValue('name')}
          />
        </div>
        <div className="col-md-4 my-2">
          <label htmlFor="emi_amount" className="form-label">EMI Amount</label><br/>
          <input
            value={leaseOffer.emi_amount}
            onChange={(e) => changeValue('emi_amount', e.target.value)}
            type="number"
            className="form-control form-control-sm font-size-12"
            id="emi_amount" placeholder='Enter EMI Amount'
          />
        </div>
        <div className="col-md-4 my-2">
          <label htmlFor="lease_amount" className="form-label">Lease Amount</label><br/>
          <input
            disabled
            value={leaseOfferObj.lease_amount}
            type="number"
            className="form-control form-control-sm font-size-12"
            id="lease_amount" placeholder='Lease Amount'
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 my-2">
          <label htmlFor="tenure" className="form-label">Business Units</label>
          <Multiselect
            selectedValues={leaseOffer.business_units}
            options={businessUnits}
            onSelect={onBusinessUnitSelect}
            onRemove={onBusinessUnitRemove}
            displayValue="name"
            showArrow={true}
            customArrow={true}
          />
        </div>
        <div className="col-md-4 my-2">
          <label htmlFor="Is Rental Lease Offer" className="form-label">Is Rental Lease Offer</label>
          <input checked={leaseOfferObj.is_rental} type="checkbox" onChange={handleRentalToggle}/>
          { 
            leaseOfferObj.is_rental && <><br/>
              <label htmlFor="tenure" className="form-label">Select Bikes</label>
              <Multiselect
                selectedValues={leaseOfferObj.bikes}
                options={bikes}
                onSelect={onBikeSelect}
                onRemove={onBikeRemove}
                displayValue="name"
                showArrow={true}
                customArrow={true}
              />
            </>
          }
        </div>
        <div className="col-md-2 my-2">
          <label htmlFor="Skip First EMI" className="form-label">Skip First EMI</label>
          <input checked={leaseOfferObj.skip_first_emi} type="checkbox" onChange={handleSkipFirstEmiToggle}/>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6 my-2">
          <label htmlFor="swap_credit_on_emi_payment" className="form-label">Swap Credit on EMI payment</label>
          <input
            value={leaseOffer.swap_credit_on_emi_payment}
            onChange={(e) => changeValue('swap_credit_on_emi_payment', e.target.value)}
            type="number"
            className="form-control form-control-sm font-size-12"
            id="swap_credit_on_emi_payment" placeholder='Enter Swap credits'
          />
        </div>
        <div className="col-md-6 my-2">
          <div className="row">
            <div>
              <span htmlFor="swap_count_frequency" className="form-label">EMI frequency swap count &ensp; </span>
              <input type="number" disabled value={leaseOffer.swap_credit_on_emi_payment}></input>
            </div>
            <div>
              <input checked={leaseOfferObj.has_emi_frequency_days} type="checkbox" onChange={handleHasSwapCreditOnEmiPayment}/>
              <span> [FILL EMI FREQUENCY SWAP COUNT] </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
};


export default FormPartial;
